module.exports = __webpack_public_path__ + "static/media/ai-solutions.05573ade.svg";